import React, { useState } from "react";
import { Button, Modal, Row } from "antd";
import SelectableFilterForm from "./SelectableFilterForm";
import { _Filter_Types } from "../../../../../Home/FiltersData";
import { isEmpty } from "lodash";

export const FilterForm = ({ selectedFilterType, selectedKey, uniqueValues, section, closeForm, mode, filter }) => {
	const [visible, setVisible] = useState(false);
	if (!selectedFilterType) return null;
	return (
		<Row justify="center">
			<Button
				disabled={!selectedFilterType || isEmpty(selectedKey)}
				type="primary"
				onClick={() => {
					setVisible(true);
				}}
			>
				{mode === "Update" ? "Update " : "Setup "}
				Filter For {selectedFilterType}
			</Button>
			{visible && (
				<Modal
					title={`Setup Filter For ${selectedFilterType}`}
					open={visible}
					onOk={() => setVisible(false)}
					onCancel={() => setVisible(false)}
					width={1000}
					footer={null}
				>
					{[_Filter_Types.Checkbox, _Filter_Types.Radio, _Filter_Types.MINMAX, _Filter_Types.Text].includes(
						selectedFilterType
					) ? (
						<SelectableFilterForm
							mode={mode}
							filter={filter}
							closeForm={() => {
								closeForm();
								setVisible(false);
							}}
							section={section}
							selectedKey={selectedKey}
							uniqueValues={uniqueValues}
							filterType={selectedFilterType}
						/>
					) : null}

					{[_Filter_Types.Recursive].includes(selectedFilterType) ? (
						<SelectableFilterForm
							mode={mode}
							filter={filter}
							closeForm={() => {
								closeForm();
								setVisible(false);
							}}
							section={section}
							selectedKey={""}
							uniqueValues={selectedKey}
							filterType={_Filter_Types.Recursive}
						/>
					) : null}
				</Modal>
			)}
		</Row>
	);
};

export default FilterForm;
